import React from 'react';
import AppHome from '../views/App/home/Home';

const homeRoutes = () => [
  {
    id: 'home',
    label: 'Home',
    path: '/app/home',
    component: <AppHome />,
    disabled: false,
    show: false,
    showInNavbar: false,
    subRoutes: [],
  },
];

export default homeRoutes;
